{
  "DYNAMIC_COMPONENT_SELECTOR": {
    "INSERT_DYNAMIC_CONTENT": "Insert dynamic content",
    "SNAPSHOT_REPORT": "Snapshot report",
    "BUSINESS_APP_DETAILS": "Business app details",
    "SALESPERSON_DETAILS": "Salesperson details",
    "PARTNER_DETAILS": "Partner details",
    "ACCOUNT_DETAILS": "Account details",
    "PRODUCT_DETAILS": "Product details",
    "CONTACT_DETAILS": "Contact details"
  },
  "DYNAMIC_COMPONENT_DIALOG": {
    "ADD_HEADING": "Add dynamic content",
    "CATEGORY": "Category",
    "CANCEL_BUTTON": "Cancel",
    "ADD_BUTTON": "Add",
    "NO_OPTIONS": "No options found"
  }
}
